import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.chat.sidebar');
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-chat-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.chat.sidebar/view.scss */
/* src/app/component.chat.sidebar/view.scss: no such file or directory */`],
})
export class ComponentChatSidebarComponent implements OnInit {
    @Input() open: boolean = false;
    public sessions: any[] = [];
    public selectedSessionId: string | null = null;
    public groupedSessions: { title: string, sessions: any[] }[] = [];
    public hoveredSessionId: string | null = null;
    public dropdownSessionId: string | null = null;
    public dropdownPosition = { top: 0, left: 0 };
    public editingSessionId: string | null = null;
    public tempSessionTitle: string = "";

    @Output() onSelectSession = new EventEmitter<string>();
    @Output() onCloseSidebar = new EventEmitter<void>();
    @Output() onNewChat = new EventEmitter<void>();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        if (this.open) await this.refreshSessions();
        document.addEventListener('click', this.closeDropdownOnOutsideClick.bind(this));
        await this.service.render();
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (changes['open'] && changes['open'].currentValue === true) {
            await this.refreshSessions();
        }
    }

    public selectSession(sessionId: string) {
        this.selectedSessionId = sessionId;
        this.onSelectSession.emit(sessionId);
        this.closeSidebar();
    }

    public async closeSidebar() {
        this.onCloseSidebar.emit();
        await this.service.render();
    }

    public async newChat() {
        this.onNewChat.emit();
        this.closeSidebar();
    }

    public async refreshSessions() {
        const { code, data } = await wiz.call("list_sessions");
        if (code === 200) {
            this.sessions = data.sessions;
            this.groupSessionsByDate();
            await this.service.render();
        }
    }

    public groupSessionsByDate() {
        const today = new Date();
        const yesterday = new Date();
        const weekAgo = new Date();
        yesterday.setDate(today.getDate() - 1);
        weekAgo.setDate(today.getDate() - 7);

        const groups = {
            "오늘": [],
            "어제": [],
            "지난 7일": [],
            "그 이전": []
        };

        for (const session of this.sessions) {
            const updatedAt = new Date(session.updated_at);
            updatedAt.setHours(0, 0, 0, 0);

            const todayDate = new Date();
            todayDate.setHours(0, 0, 0, 0);
            const yesterdayDate = new Date();
            yesterdayDate.setDate(todayDate.getDate() - 1);
            yesterdayDate.setHours(0, 0, 0, 0);

            if (updatedAt.getTime() === todayDate.getTime()) {
                groups["오늘"].push(session);
            } else if (updatedAt.getTime() === yesterdayDate.getTime()) {
                groups["어제"].push(session);
            } else if (updatedAt > weekAgo) {
                groups["지난 7일"].push(session);
            } else {
                groups["그 이전"].push(session);
            }
        }

        this.groupedSessions = Object.entries(groups)
            .filter(([_, list]) => list.length > 0)
            .map(([title, sessions]) => ({ title, sessions }));
    }

    public toggleDropdown(sessionId: string, event: MouseEvent) {
        event.stopPropagation();
        this.dropdownSessionId = this.dropdownSessionId === sessionId ? null : sessionId;
        this.service.render();
    }

    public async deleteSession(sessionId: string) {
        const confirmed = confirm("정말 이 세션을 삭제하시겠습니까?");
        if (!confirmed) return;

        await wiz.call("delete_session", { session_id: sessionId });
        await this.refreshSessions();

        if (this.selectedSessionId === sessionId) {
            this.selectedSessionId = null;
        }

        this.dropdownSessionId = null;
        this.newChat();
        await this.service.render();
    }

    closeDropdownOnOutsideClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (!target.closest('.group')) {
            this.dropdownSessionId = null;
            this.service.render();
        }
    }

    public startEditing(session: any, event: MouseEvent) {
        event.stopPropagation();
        this.editingSessionId = session.id;
        this.tempSessionTitle = session.title || "";
        this.dropdownSessionId = null;
        this.service.render();
    }


    public async saveSessionTitle(session: any, event: KeyboardEvent) {
        if (event.key !== "Enter") return;

        const newTitle = this.tempSessionTitle.trim();
        if (!newTitle || newTitle === session.title) {
            this.editingSessionId = null;
            return;
        }

        await wiz.call("update_session_title", {
            session_id: session.id,
            title: newTitle
        });

        await this.refreshSessions();
        this.editingSessionId = null;
    }

}

export default ComponentChatSidebarComponent;